import { render } from "./Personal.vue?vue&type=template&id=2e5bdf20&scoped=true"
import script from "./Personal.vue?vue&type=script&lang=ts"
export * from "./Personal.vue?vue&type=script&lang=ts"

import "./Personal.vue?vue&type=style&index=0&id=2e5bdf20&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-2e5bdf20"

export default script